import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Avatar,
  Typography,
  Stack,
} from "@mui/material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

/**
 * Se muestra al terminar de emitir una factura a un cliente de cuenta corriente
 * (cuando el recibo NO es obligatorio). Pregunta si se quiere cargar el recibo
 * en el momento o dejarlo para después.
 */
const DialogConfirmarRecibo = ({ open, onSi, onNo }) => {
  return (
    <Dialog open={open} onClose={onNo} maxWidth="xs" fullWidth>
      <Box
        sx={{
          background: "linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)",
          height: 8,
        }}
      />
      <DialogContent sx={{ pt: 3, pb: 1 }}>
        <Stack spacing={2} alignItems="center" textAlign="center">
          <Avatar
            sx={{
              bgcolor: "#E3F2FD",
              width: 64,
              height: 64,
              boxShadow: "0 4px 14px rgba(25, 118, 210, 0.25)",
            }}
          >
            <ReceiptLongIcon sx={{ fontSize: 40, color: "#1976d2" }} />
          </Avatar>
          <Typography variant="h6" fontWeight={700}>
            ¿Querés cargar un recibo ahora?
          </Typography>
          <Typography variant="body2" color="text.secondary">
            La factura ya fue emitida y quedó en la cuenta corriente del cliente.
            Podés registrar el pago ahora o hacerlo más tarde desde su cuenta
            corriente.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 2.5, gap: 1, justifyContent: "space-between" }}>
        <Button
          variant="outlined"
          color="inherit"
          onClick={onNo}
          sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, px: 3 }}
        >
          Ahora no
        </Button>
        <Button
          variant="contained"
          onClick={onSi}
          startIcon={<ReceiptLongIcon />}
          sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, px: 3 }}
        >
          Sí, cargar recibo
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirmarRecibo;
